/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Stores } from '../../models/stores';

export interface DataGroupsDataGroupIdStoresGet$Params {
  'Active-Tenant-Identifier': string;
  dataGroupId: string;
}

export function dataGroupsDataGroupIdStoresGet(http: HttpClient, rootUrl: string, params: DataGroupsDataGroupIdStoresGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Stores>> {
  const rb = new RequestBuilder(rootUrl, dataGroupsDataGroupIdStoresGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('dataGroupId', params.dataGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Stores>;
    })
  );
}

dataGroupsDataGroupIdStoresGet.PATH = '/data-groups/{dataGroupId}/stores';
